import React, { useState, useEffect } from "react";
import PredictionCard from "components/card/PredictionCard";
import { getPredictors } from "api-algolia/predictors.api";
import { createPrediction } from "api/predictions.api";

const PredictionModal = ({ data, isOpen, onClose }) => {
  const [cardItem, setCardItem] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !data) return;

    const fetchPredictor = async () => {
      const authorName = data.authorName || "";
      const [firstName, ...lastNameParts] = authorName.split(" ");
      const lastName = lastNameParts.join(" ");

      try {
        const result = await getPredictors({
          searchText: authorName,
          length: 1,
        });

        const predictorData =
          result.hits && result.hits.length > 0 ? result.hits[0] : null;

        const mappedItem = {
          title:
            data.analysis?.predictionTitle ||
            data.predictionTitle ||
            data.title,
          description:
            data.analysis?.publishSummary ||
            data.publishSummary ||
            data.publishArticle,
          predictor: predictorData
            ? { ...predictorData }
            : { firstName, lastName, image: data.authorImage || null },
          image: data.image || null,
          endOfVoting: null,
          deadline: null,
          type: "new",
          result: null,
        };

        setCardItem(mappedItem);
      } catch (err) {
        console.error("Error fetching predictor:", err);
      }
    };

    fetchPredictor();
  }, [isOpen, data]);

  const handleCreatePrediction = async () => {
    if (!cardItem) return;

    setLoading(true);

    try {
      const newDoc = await createPrediction({
        title: cardItem.title,
        description: cardItem.description,
        predictor: cardItem.predictor,
        image: cardItem.image,
        createdAt: Date.now(),
        type: "new",
      });

      if (newDoc?.id) {
        // Redirect to manage page
        window.location.href = `/predictions/manage/${newDoc.id}`;
      } else {
        console.error("Failed to create prediction");
      }
    } catch (err) {
      console.error("Error creating prediction:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !cardItem) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[600px] max-w-full relative">
        <button
          className="absolute top-4 right-4 text-gray-600 font-bold"
          onClick={onClose}
        >
          X
        </button>

        <PredictionCard
          showTimers
          isDisabled
          hidePrimaryButton
          item={cardItem}
          isSelected={false}
          onCardClick={() => {}}
        />

        {/* Create Prediction Button */}
        <div className="mt-4 text-center">
          <button
            onClick={handleCreatePrediction}
            disabled={loading}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
          >
            {loading ? "Ստեղծվում է..." : "Ստեղծել կանխատեսում"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PredictionModal;
